import { MessageVariant, MessageSeverity } from './../../directives/message.directive';
import { ManualImportService } from './manual-import.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GridComponent, GridModule } from '@syncfusion/ej2-angular-grids';
import { TitleBarComponent } from 'src/app/base/shared/title-bar/title-bar.component';
import { AsyncSettingsModel, CancelEventArgs, RemovingEventArgs, SelectedEventArgs, Uploader, UploaderModule, UploadingEventArgs } from '@syncfusion/ej2-angular-inputs';
import { environment } from 'src/environments/environment';
import { ToastService } from 'src/app/base/services/toast.service';
import { AuthService } from 'src/app/base/services/auth.service';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';

import { DSSProcessingLogStatus, ImportProtocolLogEntryDTO, ImportType } from 'src/app/base/models/models.swagger.generated';
import { ActivatedRoute } from '@angular/router';
import { MessageModule } from '@syncfusion/ej2-angular-notifications';
import { MessageDirective } from 'src/app/directives/message.directive';

@Component({
    selector: 'app-manual-import',
    templateUrl: './manual-import.component.html',
    styleUrls: ['./manual-import.component.scss'],
    imports: [TitleBarComponent, TranslateModule, GridModule, UploaderModule, TooltipModule, MessageModule, MessageDirective]
})
export class ManualImportComponent implements OnInit {

  @ViewChild('defaultupload')
  public defaultupload: Uploader;

  @ViewChild('grid')
  public grid: GridComponent;

  public protocols: ImportProtocolLogEntryDTO[] = [];
  public DSSProcessingLogStatus = DSSProcessingLogStatus;

  public importType: ImportType;

  ImportType = ImportType;

  MessageVariant = MessageVariant;
  MessageSeverity = MessageSeverity;

  public asyncSettings: AsyncSettingsModel = {
    saveUrl: ""
  };

  constructor(public toastService: ToastService,
    private authService: AuthService,
    private translateService: TranslateService,
    private manualImportService: ManualImportService,
    private route: ActivatedRoute,) {
  }

  ngOnInit() {
    this.authService.loadUserInfoDTO();

    //Get import type from route data
    this.importType = this.route.snapshot.data.importType;
    this.asyncSettings.saveUrl = environment.apiServerUrl + environment.manualImportRoute + 'UploadManualImport?importType=' + this.importType;
  }

  public onCanceling(args: CancelEventArgs): void {
    args.customFormData = [{ Authorization: 'Bearer ' + this.authService.getBearerToken() }];
  }

  public onRemoving(args: RemovingEventArgs): void {
    this.authService.loadUserInfoDTO();
    this.protocols = [];
  }

  public onUploading(args: UploadingEventArgs): void {
    args.currentRequest?.setRequestHeader('Authorization', 'Bearer ' + this.authService.getBearerToken());
  }

  public onUploadFailed(args: any) {
    this.authService.loadUserInfoDTO();
  }

  public onFileSelected(args: SelectedEventArgs) {
    this.protocols = [];
  }

  public onUploadSuccess(args: any) {
    var data = JSON.parse(args.e.target.response);
    data.forEach(element => {
      this.protocols.push(ImportProtocolLogEntryDTO.fromJS(element))
    });
    this.grid.refresh();
  }

  public formatEntryState(state: DSSProcessingLogStatus): string {
    if (state == null) {
      return '';
    }
    return this.translateService.instant('i18n.shared.dss-processing-log-state.' + DSSProcessingLogStatus[state]);
  }

  public downloadTemplate() {
    this.manualImportService.downloadTemplate(this.importType).subscribe((response) => {
      const source = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = source;
      link.download = response.fileName ?? 'template.xlsx';
      link.click();
    });
  }
}
